import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subMsg, setSubMsg] = useState('');

  const handleNewsletter = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    try {
      const body = new URLSearchParams({ email });
      await fetch('https://readdy.ai/api/form/d70r5cf9hgr6oot2r4r0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubMsg('Thanks for subscribing!');
      setEmail('');
    } catch {
      setSubMsg('Error, please try again.');
    }
  };

  return (
    <footer style={{ fontFamily: "'Nunito', sans-serif", backgroundColor: '#F5F2FD' }}>
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-4 cursor-pointer">
              <img
                src="https://storage.readdy-site.link/project_files/6541567e-6f9e-4c0d-a197-6ac1391c9a7a/110f37e5-96e8-4c69-ac75-99d73641fb18_410-DP3---2.png?v=ad04a06fe90851ea0575a478e492e2f4"
                alt="Little Loop"
                className="h-10 object-contain"
              />
            </Link>
            <p className="text-sm text-gray-500 leading-relaxed">
              Second-hand clothing and used toys for kids ages 1 to 12. Sustainable, affordable, and made with love.
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" rel="nofollow" className="flex items-center justify-center w-8 h-8 rounded-full bg-brand-purple-light text-brand-purple hover:bg-brand-purple hover:text-white transition-colors cursor-pointer">
                <i className="ri-instagram-line text-base"></i>
              </a>
              <a href="#" rel="nofollow" className="flex items-center justify-center w-8 h-8 rounded-full bg-brand-purple-light text-brand-purple hover:bg-brand-purple hover:text-white transition-colors cursor-pointer">
                <i className="ri-facebook-line text-base"></i>
              </a>
            </div>
          </div>

          {/* Shop */}
          <div>
            <h4 className="font-700 text-gray-800 mb-4 text-sm uppercase tracking-wider" style={{ fontWeight: 700 }}>Shop</h4>
            <ul className="space-y-2">
              {['Clothing 1-3 yrs', 'Clothing 4-7 yrs', 'Clothing 8-12 yrs', 'Toys', 'Sale'].map(item => (
                <li key={item}>
                  <Link to="/products" className="text-sm text-gray-500 hover:text-brand-yellow transition-colors cursor-pointer">{item}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Info */}
          <div>
            <h4 className="font-700 text-gray-800 mb-4 text-sm uppercase tracking-wider" style={{ fontWeight: 700 }}>Information</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-gray-500 hover:text-brand-yellow transition-colors cursor-pointer">About Us</Link></li>
              <li><Link to="/contact" className="text-sm text-gray-500 hover:text-brand-yellow transition-colors cursor-pointer">Contact</Link></li>
              <li><Link to="/privacy" className="text-sm text-gray-500 hover:text-brand-yellow transition-colors cursor-pointer">Privacy Policy</Link></li>
              <li><Link to="/privacy#returns" className="text-sm text-gray-500 hover:text-brand-yellow transition-colors cursor-pointer">Return Policy</Link></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-700 text-gray-800 mb-4 text-sm uppercase tracking-wider" style={{ fontWeight: 700 }}>Newsletter</h4>
            <p className="text-sm text-gray-500 mb-3">Get deals and new arrivals in your inbox.</p>
            <form onSubmit={handleNewsletter} data-readdy-form className="flex gap-2">
              <input
                type="email"
                name="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Your email"
                className="flex-1 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-brand-yellow bg-white"
                required
              />
              <button
                type="submit"
                className="bg-brand-yellow text-white px-4 py-2 rounded-lg text-sm font-600 hover:bg-brand-yellow-dark transition-colors cursor-pointer whitespace-nowrap"
                style={{ fontWeight: 600 }}
              >
                OK
              </button>
            </form>
            {subMsg && <p className="text-xs text-brand-green mt-2">{subMsg}</p>}
          </div>
        </div>
      </div>

      <div className="border-t border-brand-purple-light">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-2">
          <p className="text-xs text-gray-400">© 2026 Little Loop. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-xs text-gray-400 hover:text-brand-yellow transition-colors cursor-pointer">Privacy</Link>
            <span className="text-gray-300">|</span>
            <Link to="/privacy#returns" className="text-xs text-gray-400 hover:text-brand-yellow transition-colors cursor-pointer">Returns</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
